"use client";

import { useRouter } from "next/navigation";

export default function UnexpectedErrorPage() {
    const router = useRouter();

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white text-zinc-800 px-6">
            <h1 className="text-6xl font-bold mb-4 text-center">Access Denied</h1>
            <p className="text-lg text-center max-w-2xl mb-6">
                You do not have permission to access this page. If you believe this is an error, please contact Customer Support.
            </p>
            <div className="flex gap-4">
                <button
                    onClick={() => router.push("/")}
                    className="px-6 py-2 rounded-3xl bg-[#213735] hover:bg-[#1e3230] text-white transition-colors"
                >
                    Return Home
                </button>
            </div>
        </div>
    );
}